<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
        <el-button type="primary" plain class="title-btn" @click="back()">返回</el-button>
      </div>
      <div style="width: 500px;" class="detail">
        <el-form ref="ruleForm" :model="ruleForm" label-width="100px">
          <el-form-item label="活动名称" prop="activityName">
            <el-input v-model="ruleForm.activityName" :disabled="true" />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker v-model="ruleForm.activityTime" :disabled="true" type="daterange" range-separator="至" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="活动说明" prop="activityExplain">
            <el-input v-model="ruleForm.activityExplain" :disabled="true" type="textarea" :rows="4" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px;" class="detail">
        <el-form ref="configForm" :model="configForm" label-width="100px">
          <el-form-item label="消费维度" prop="consumptionDimension">
            <el-radio-group v-model="configForm.consumptionDimension" disabled>
              <el-radio label="2">金额</el-radio>
              <el-radio label="1">电量</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖励标准" prop="amount">
            <div class="d-flex rewardStandard">
              <div>满</div>
              <el-input v-model="configForm.amount" disabled />
              <div>{{ configForm.consumptionDimension==='1'?'度':'元' }}</div>
            </div>
          </el-form-item>
          <template v-for="(row,index) in configForm.coupon">
            <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)" prop="coupon">
              <div class="d-flex">
                <el-select v-model="row.couponId" disabled style="width: 200px;">
                  <el-option v-for="item in allCoupon" :key="item.couponId" :label="item.couponName" :value="item.couponId" />
                </el-select>
                <el-input v-model="row.count" disabled class="ml-20" style="width: 100px;" />
                <div class="ml-20">张</div>
              </div>
              <div class="d-flex currentStock">当前库存：{{ queryCouponStock(row.couponId) }}</div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">用户参与记录</span>
      </div>
      <STable
        ref="firstDetailTableref"
        :url="url"
        :columns="columns"
        :query="query"
        :selection="false"
        :toolbar="toolbar"
        label-width="100px"
      />
    </el-card>
  </div>
</template>

<script>
import { numberfilter } from '@/utils/tool'
import { HOST } from '@/utils/host'
import { treeDisabled } from '@/utils/tool'
export default {
  props: {
    // 预留的id，通过id查询详情信息
    // id: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      id:0,
      ruleForm: {
        activityName: '', // 活动名称
        activityTime: [], // 活动时间
        activityExplain: ''// 活动说明
      },
      // 所有的优惠券数据
      allCoupon: [],
      configForm: {
        consumptionDimension: '2', // 消费维度
        amount: '', // 奖励标准
        coupon: [// 优惠券
          {
            couponId: '', // 优惠券id
            count: '' // 优惠券数量
          }
        ]
      },
      url: '/activity/pageParticipation',
      columns: [
        {
          label: '所属企业',
          prop: 'orgName'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          prop: 'userName'
        },
        {
          label: '手机号',
          prop: 'mobile'
        },
        {
          label: '消费金额/充电度数',
          prop: 'amount',
          template: (index, reocrd) => {
            if (this.configForm.consumptionDimension == '1') {
              return this.getFloat(reocrd.amount)+'度'
            } else {
              return this.getFixed2(reocrd.amount)+'元'
            }
          }
        },
        {
          label: '消费时间',
          prop: 'createTime'
        }
      ],
      query: [
        {
          label: '所属企业',
          prop: 'orgName',
          placeholder: '请输入企业名称'
        }, {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        }, {
          label: '手机号',
          prop: 'mobile',
          placeholder: '请输入手机号'
        }, {
          label: '消费时间',
          prop: 'timeRange',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '导出',
          icon: 'el-icon-download',
          type: 'primary',
          handle: (resp) => {
            const url = HOST + '/activity/exportParticipation?activityId=' + this.id
            const data = this.$refs.firstDetailTableref.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出用户参与记录失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  computed: {},
  beforeMount() {
    this.id=this.$route.query.id
    this.url = '/activity/pageParticipation?activityId=' + this.$route.query.id
  },
  mounted() {
    // 接收数据后回显赋值
    this.$nextTick(() => {
      // 获取全部优惠券数据
      this.loadCoupon()
      // 页面数据转换接口
      this.getData()
    })
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.allCoupon = resp.list
            this.$forceUpdate()
          }
        }
      })
    },
    // 页面数据转换方法
    getData() {
      this.$store.dispatch('form/handle', {
        url: '/activity/get',
        data: { id: this.id },
        method: 'get',
        callback: (record) => {
          this.ruleForm = {
            activityName: record.name, // 活动名称
            activityTime: [record.start, record.end], // 活动时间
            activityExplain: record.description // 活动说明
          }
          this.configForm = {
            consumptionDimension: record.consumptionType, // 消费维度
            amount: record.coupons[0].amount, // 奖励标准
            coupon: record.coupons[0].coupons
          }
        }
      })
    },
    // 查询优惠券库存
    queryCouponStock(id) {
      const val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      if (!val) return ''
      return val.stock || 0
    },
    back() {
      // this.$emit('backHome')
        this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .detail{
    /deep/.el-input__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-textarea__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-input{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-separator{
      color: #606266 !important;
    }
    /deep/.el-range__icon{
      color: #606266 !important;
    }
  }
  .d-flex{
    display: flex;
  }
  .currentStock{
    height: 20px;
    align-items: center;
  }
  .ml-20{
    margin-left: 20px;
  }
  .icon-jia{
    font-size: 22px;
    align-items: center;
    display: flex;
  }
  .border{
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
  .rewardStandard{
    /deep/.el-input{
      width: 70%;
      padding: 0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/firstDetail.vue